<template>
  <div class="orderGoods" v-if="cartInfo.length > 0">
    <div class="total">共{{ cartInfo.length }}个项目</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="info in cartInfo"
        :key="info.id"
      >
        <div class="pictrue">
          <img
            :src="info.itemPic + '!tmb_130'"
            class="image"
            v-if="info.itemPic"
          />
          <img src="@assets/images/def_service.jpg" class="no-pictrue" v-else />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ info.itemName }}</div>
            <div class="num">x {{ info.num }}</div>
          </div>
          <div class="attr line1" v-if="info.waiterName">
            服务顾问： {{ info.waiterName }}
          </div>
          <div class="money font-color-red">￥{{ info.price }}</div>
          <div
            class="evaluate"
            v-if="evaluate === 1"
            @click="$router.push({ path: `/order/sign/${order.id}` })"
          >
            去签字
          </div>
          <div
            class="evaluate"
            v-if="evaluate === 2 && order.isComment === 0"
            @click="$router.push({ path: `/order/comment/${order.id}` })"
          >
            去评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    order: Object,
    cartInfo: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.orderGoods {
  .item {
    .pictrue {
      width: 1.2rem;
      height: 1.2rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.06rem;
      }
    }
  }

  .no-pictrue {
    width: 90px;
    height: 90px;
    border-radius: 2px;
    border: 1px solid #c3cbd6;
  }
}
</style>
